import { render, staticRenderFns } from "./backV1Icon.vue?vue&type=template&id=69316a8b&"
import script from "./backV1Icon.vue?vue&type=script&lang=js&"
export * from "./backV1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports